module.exports = __webpack_public_path__ + "static/media/referral.b52b66a4.svg";